import { render } from "./PublicationTable.vue?vue&type=template&id=f2d61adc"
import script from "./PublicationTable.vue?vue&type=script&lang=js"
export * from "./PublicationTable.vue?vue&type=script&lang=js"
script.render = render

export default script